function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M30.93 4.75a12.171 12.171 0 0 0-9.09 3.55c-3.113 3.122-3.524 6.852-2.102 10.4L6.586 31.851a6.316 6.316 0 0 0 8.934 8.93l13.148-13.15c3.547 1.419 7.277 1.013 10.39-2.105 3.34-3.336 4.325-8.117 2.989-12.316l-7.309 7.316-6.316-1.578-1.578-6.316 7.308-7.317a12.327 12.327 0 0 0-3.222-.566ZM11.05 33.156a3.16 3.16 0 1 1 .003 6.319 3.16 3.16 0 0 1-.002-6.319Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterMaintenance);
export default __webpack_public_path__ + "static/media/enter-maintenance.aa6ed2739caf144292e208a92ea9047c.svg";
export { ForwardRef as ReactComponent };